import { HashLink } from 'react-router-hash-link';
import Container from '../Container';
import IconkaEmail from '../../pictures/icon-email.png';
import IconkaTelephon from '../../pictures/icons8-ringing-phone-64.png';
import './footer.css';
import Text from '../Text/index';
import { Link } from 'react-router-dom';
import Dinax_logo_white from '../../pictures/DSblack.jpg';

const Footer = () => {
  return (
    <footer className="section-footer">
      <Container>
        <div className="section-footer-wrapper">
          <div className="section-footer-content">
            <div className="section-footer-content--logo">
              <Link to="/">
                <img src={Dinax_logo_white} alt="" />
              </Link>
            </div>
            <div className="section-footer-content--text">
              <HashLink to="/okompanuu">О компании</HashLink>
              <HashLink to="/fill_the_form">Связаться с нами</HashLink>
              <HashLink to="/">Информация о юридическом лице</HashLink>
            </div>
            <div className="section-footer-content--connect">
              <Text component="p" size="sm">
                Связаться с нами:
              </Text>

              <div>
                <img src={IconkaEmail} alt="" />
                <Text
                  component="a"
                  section="footer"
                  href="mailto:dinaxsystems@yandex.ru"
                >
                  dinaxsystems@yandex.ru
                </Text>
              </div>

              <div>
                <img src={IconkaTelephon} alt="" />
                <Text
                  component="a"
                  section="footer"
                  href="tel:+7(952)200-83-34"
                >
                  +7(952)200-83-34
                </Text>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};
export default Footer;
